<div class="custom_select" [id]="id">
  <div class="select_container">
    <!--  <div class="selected_option" (click)="viewOptions();" >
      <em [class]="icon"></em>
    </div>
    <ul class="options_list" *ngIf="showOptions">
      <li
        *ngFor="let option of options"
        (click)="selectOption(option)"
        [ngClass]="{'option_active': option == label}"
      >
        {{ option }}
      </li>
    </ul> -->

    <div
      [placement]="['bottom', 'top']"
      class="d-inline-block custom_select"
      ngbDropdown
      #myDrop="ngbDropdown"
      [id]="id"
    >
      <button
        class="selected_option btn"
        (click)="viewOptions();"
        id="custom_select"
        ngbDropdownAnchor
        (focus)="myDrop.open()"
      >
        <em [class]="icon"></em>
      </button>
      <div
        ngbDropdownMenu
        aria-labelledby="custom_select"
        [ngStyle]="{'width':width }"
        class="p-0"
        *ngIf="showOptions"
      >
        <ul class="options_list" [class]="class_options" ngbDropdownItem>
          <li
            *ngFor="let option of options"
            (click)="selectOption(option)"
            [ngClass]="{'option_active': option == label}"
          >
            {{ option }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
